import { ProductId } from '../schemas/products.schemas';
import anarchyCloudAllAccess from '../../../assets/images/thumbnails/anarchy-cloud-all-access.jpg';
import anarchyCloudOneApp from '../../../assets/images/thumbnails/anarchy-cloud-one-app.jpg';
import anarchyCompleteBundleAllPlugins from '../../../assets/images/thumbnails/anarchy-complete-bundle-all-plugins.jpg';
import effIt from '../../../assets/images/thumbnails/eff-it.png';
import beautyBoxCrossgrade from '../../../assets/images/thumbnails/beauty-box-crossgrade.jpg';
import beautyBoxPhotoUpgrade from '../../../assets/images/thumbnails/beauty-box-photo-upgrade.jpg';
import beautyBoxPhoto from '../../../assets/images/thumbnails/beauty-box-photo.jpg';
import beautyBoxUpgrade123 from '../../../assets/images/thumbnails/beauty-box-upgrade-123.jpg';
import beautyBoxUpgrade from '../../../assets/images/thumbnails/beauty-box-upgrade.jpg';
import beautyBox from '../../../assets/images/thumbnails/beauty-box.jpg';

import beautyBox6 from '../../../assets/images/thumbnails/bb6.jpg';
import beautyBoxUpgrade1to4 from '../../../assets/images/thumbnails/bb6-up1-4.jpg';
import beautyBoxUpgrade5to6 from '../../../assets/images/thumbnails/bb6-up5.jpg';

import dataStoryTellerCrossgrade from '../../../assets/images/thumbnails/data-storyteller-crossgrade.jpg';
import dataStoryTeller from '../../../assets/images/thumbnails/datastoryteller.jpg';
import flickerFreeCrossgrade from '../../../assets/images/thumbnails/flicker-free-crossgrade.jpg';
import flickerFreeUpgrade from '../../../assets/images/thumbnails/flicker-free-upgrade.jpg';
import flickerFree from '../../../assets/images/thumbnails/flicker-free.jpg';
import flickerFree3 from '../../../assets/images/thumbnails/FF3.jpg';
import flickerFree1to3upgrade from '../../../assets/images/thumbnails/FF3-1to3upgrade.jpg';
import flickerFree2to3upgrade from '../../../assets/images/thumbnails/FF3-2to3upgrade.jpg';
import placeholder from '../../../assets/images/thumbnails/placeholder.png';
import powerSearch from '../../../assets/images/thumbnails/powersearch.jpg';
import samuraiSharpenCrossgrade from '../../../assets/images/thumbnails/samurai-sharpen-crossgrade.jpg';
import samuraiSharpen from '../../../assets/images/thumbnails/samurai-sharpen.jpg';
import lightWrapCrossgrade from '../../../assets/images/thumbnails/the-light-wrap-crossgrade.jpg';
import lightWrap from '../../../assets/images/thumbnails/the-light-wrap.jpg';
import transcriptiveUpgrade from '../../../assets/images/thumbnails/transcriptive-upgrade.jpg';
import transcriptive from '../../../assets/images/thumbnails/transcriptive.jpg';

const productThumbnails = new Map<ProductId | string, string>([
  ['cloud-all-access', anarchyCloudAllAccess],
  ['cloud-one-app', anarchyCloudOneApp],
  ['cloud-complete-bundle-all-plugins', anarchyCompleteBundleAllPlugins],
  ['eff-it', effIt],
  ['beauty-box-6', beautyBox6],
  ['beauty-box-6-upgrade-1to4', beautyBoxUpgrade1to4],
  ['beauty-box-6-upgrade-5to6', beautyBoxUpgrade5to6],
  ['beauty-box', beautyBox],
  ['beauty-box-photo', beautyBoxPhoto],
  ['beauty-box-upgrade', beautyBoxUpgrade],
  ['beauty-box-upgrade-123', beautyBoxUpgrade123],
  ['beauty-box-photo-upgrade', beautyBoxPhotoUpgrade],
  ['beauty-box-crossgrade', beautyBoxCrossgrade],
  ['data-storyteller', dataStoryTeller],
  ['data-storyteller-crossgrade', dataStoryTellerCrossgrade],
  ['flicker-free', flickerFree],
  ['flicker-free-3', flickerFree3],
  ['flicker-free-upgrade-1to3', flickerFree1to3upgrade],
  ['flicker-free-upgrade-2to3', flickerFree2to3upgrade],
  ['flicker-free-upgrade', flickerFreeUpgrade],
  ['flicker-free-crossgrade', flickerFreeCrossgrade],
  ['lightwrap', lightWrap],
  ['lightwrap-crossgrade', lightWrapCrossgrade],
  ['powersearch', powerSearch],
  ['samurai-sharpen', samuraiSharpen],
  ['samurai-sharpen-crossgrade', samuraiSharpenCrossgrade],
  ['transcriptive', transcriptive],
  ['transcriptive-upgrade', transcriptiveUpgrade],
  ['placeholder', placeholder],
]);

export default productThumbnails;
